<div class="tw-w-full tw-h-full toolbar tw-px-3" #toolbar>
  <div class="prev-scroll" (click)="onPrev()" *ngIf="showPrevArrow" @fadeInAnimation>
    <span nz-icon nzType="caret-left" nzTheme="outline"></span>
  </div>
  <ng-scrollbar #ngScrollbar [track]="'horizontal'" class="tw-w-full" [thumbClass]="'tw-opacity-0'">
    <div class="toolbar-content" #toolbarContent>
      <div class="multiple modali meal-plan-options">
        <div
          class="item tw-text-xs smae-option"
          [class.selected]="this.mealPlanType.selected === this.mealPlanType.types.SMAE"
          nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="tplMealPlanTypeSMAE" [nzPopoverOverlayClassName]="'toolbar-meal-plan'"
          (click)="this.onChangeMealPlanType(this.mealPlanType.types.SMAE)"
          [ngClass]="{'disable': disabledMealPlanTypes?.includes(this.mealPlanType.types.SMAE)}"
        >
          SMAE
        </div>
        <div
          class="item tw-text-xs"
          [class.selected]="this.mealPlanType.selected === this.mealPlanType.types.INTERNATIONAL"
          nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="tplMealPlanTypeInternational" [nzPopoverOverlayClassName]="'toolbar-meal-plan'"
          (click)="this.onChangeMealPlanType(this.mealPlanType.types.INTERNATIONAL)"
          [ngClass]="{'disable': disabledMealPlanTypes?.includes(this.mealPlanType.types.INTERNATIONAL)}"
        >
          Internacional
        </div>
      </div>
      <ng-container *ngIf="this.mealPlanType.selected === this.mealPlanType.types.SMAE && this.viewSMAESteps === true">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="multiple">
          <div class="item tw-text-xs show-guidelines" (click)="this.onEmitViewSMAESteps(!this.viewSMAESteps)" [ngClass]="{'selected': !this.viewSMAESteps}" nz-popover [nzPopoverPlacement]="'bottomCenter'" [nzPopoverTitle]="''" [nzPopoverContent]="'Volver a mostrar pautas SMAE'" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/icons8-steps-64.png" alt="">
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="smaeResult && this.mealPlanType.selected === this.mealPlanType.types.SMAE && !this.viewSMAESteps">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="multiple">
          <div class="item tw-text-xs show-guidelines" (click)="this.onViewPeriods()" [ngClass]="{'selected': this.viewSMAESteps}" nz-popover [nzPopoverPlacement]="'bottomCenter'" [nzPopoverTitle]="''" [nzPopoverContent]="'Ver tiempos de comida del plan de alimentación'" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/board.png" alt="">
          </div>
        </div>
      </ng-container>
      <ng-container  *ngIf="showStandardDistribution && standardDistributionValues">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="simple ">
          <div class="item distribution-standart" nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="tplStrategyMacros" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/icon-nut.png" alt="">
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showMacros">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="simple">
          <div class="item meal-plan-macronutrient" nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="tplMacros" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/icons8-nutrition-64.png" alt="">
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showMicros">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="simple">
          <div class="item meal-plan-micronutrient" nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="tplMicros" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/icons8-calculadora-de-calorias-de-alimentos-saludables-96.png" alt="">
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showTrackingCalories">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="simple">
          <div class="item meal-plan-calories" nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="tplTrackingCalories" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/icons8-energia-calorica-64.png" alt="">
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showDistributionAlert">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="simple">
          <div class="item meal-plan-alert" nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="tplAlerts" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/icons8-sirena-96.png" alt="">
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showPatient">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="simple">
          <div class="item" nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="tplPatient" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <span nz-icon nzType="user" nzTheme="outline"></span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showTemplates">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="multiple template-plans">
          <div class="item tw-text-xs template-plan-day" (click)="this.onSelectTemplatePlanType(this.templatePlanTypeEnum.DAY)" [ngClass]="{'selected': this.templatePlanTypeSelected === this.templatePlanTypeEnum.DAY}" nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="isDesktop ? templateDayTpl : ''" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/icons8-calendar-week1-96.png" alt="">
          </div>
          <div class="item tw-text-xs template-plan-week" (click)="this.onSelectTemplatePlanType(this.templatePlanTypeEnum.WEEKLY)" [ngClass]="{'selected': this.templatePlanTypeSelected === this.templatePlanTypeEnum.WEEKLY}" nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="isDesktop ? templateWeekTpl : ''" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/icons8-calendar-week7-96.png" alt="">
          </div>
          <div class="item tw-text-xs template-plan-custom" (click)="this.onSelectTemplatePlanType(this.templatePlanTypeEnum.CUSTOM)" [ngClass]="{'selected': this.templatePlanTypeSelected === this.templatePlanTypeEnum.CUSTOM}" nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="isDesktop ? templateCustomTpl : ''" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/icons8-fecha-hasta-96.png" alt="">
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="smaeResult && this.mealPlanType.selected === this.mealPlanType.types.SMAE">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="simple">
          <div class="item meal-plan-results" nz-popover nzPopoverPlacement="bottom"[nzPopoverTitle]="''" [nzPopoverContent]="tableSmaeTpl">
            <img class="tw-w-6" src="../../../assets/images/icons/icons8-data-sheet-64.png" alt="">
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="smaeResult && this.mealPlanType.selected === this.mealPlanType.types.SMAE && hasValuesCategoryIngredientsCount">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="simple">
          <div class="item meal-plan-portion" nz-popover="" nzPopoverPlacement="bottom" [nzPopoverTitle]="''" [nzPopoverContent]="categoryIngredientsCount ? tplAlertsSmaeIngredientsCount : 'Para mostrar valores es requerido crear plan alimenticio'" [nzPopoverOverlayClassName]="'toolbar-meal-plan'">
            <img class="tw-w-6" src="../../../assets/images/icons/icons8-balanza-96.png" alt="">
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isOfficial">
        <nz-divider nzType="vertical"></nz-divider>
        <div class="simple" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="'Este plan de alimentación es original de Dèliè Nutrición'">
          <div class="item item-delie-original">
            <img src="/assets/images/icons/verified-delie.png" alt="" class="tw-w-6 tw-mr-1">
            <span class="tw-text-xs">Dèliè oficial</span>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-scrollbar>
  <div class="next-scroll" (click)="onNext()" *ngIf="showNextArrow" @fadeInAnimation>
    <span nz-icon nzType="caret-right" nzTheme="outline"></span>
  </div>
</div>

<!-- TIPO DE PLAN DE ALIMENTACION -> SMAE - INTERNACIONAL -->
<ng-template #tplMealPlanTypeSMAE>
  <p class="tw-text-xs tw-uppercase tw-text-gray-600">
    Crear plan alimenticio siguiendo las pautas de SMAE
  </p>
</ng-template>
<ng-template #tplMealPlanTypeInternational>
  <p class="tw-text-xs tw-uppercase tw-text-gray-600">
    Crear plan alimenticio siguiendo las pautas internacionales
  </p>
</ng-template>

<!-- MACRONUTRIENTES -->
<ng-template #tplMacros>
  <div class="tw-w-72 md:tw-w-96" *ngIf="nutritionalPropertiesMealPlan">
    <p class="tw-text-xs tw-uppercase tw-text-gray-600 tw-mb-5">Macronutrientes generales del plan de alimentación</p>
    <div class="macronutrients macros-in-select d-flex justify-content-between tw-text-teal-900 tw-gap-5">
      <div class="macronutrient d-flex flex-column justify-content-center
        align-items-center">
        <img loading="lazy" class="img-macro tw-w-6"
             src="./assets/images/icons/icons8-chocolatina-100.png" alt="">
        <p class="tw-text-xs tw-text-gray-600">Calorías</p>
        <p class="text-bold text-small tw-text-teal-900">{{
          +(nutritionalPropertiesMealPlan?.energy_kcal?.toFixed(2)) ?? 0 }} kcal</p>
      </div>
      <div class="macronutrient d-flex flex-column justify-content-center
        align-items-center">
        <img loading="lazy" class="img-macro tw-w-6"
             src="./assets/images/icons/icons8-sunny-side-up-huevos-100.png"
             alt="">
        <p class="tw-text-xs tw-text-gray-600">Grasas</p>
        <p class="text-bold text-small tw-text-teal-900">{{
          +(nutritionalPropertiesMealPlan?.totalFat_g?.toFixed(2)) ?? 0 }} g</p>
      </div>
      <div class="macronutrient d-flex flex-column justify-content-center
        align-items-center">
        <img loading="lazy" class="img-macro tw-w-6"
             src="./assets/images/icons/icons8-pastel-de-nata-100.png" alt="">
        <p class="tw-text-xs tw-text-gray-600">H.C</p>
        <p class="text-bold text-small tw-text-teal-900">{{
          +(nutritionalPropertiesMealPlan?.carbohydrate_g?.toFixed(2)) ?? 0 }} g</p>
      </div>
      <div class="macronutrient d-flex flex-column justify-content-center
        align-items-center">
        <img loading="lazy" class="img-macro tw-w-6" src="./assets/images/icons/icons8-jamon-100.png"
             alt="">
        <p class="tw-text-xs tw-text-gray-600">Proteínas</p>
        <p class="text-bold text-small tw-text-teal-900">{{
          +(nutritionalPropertiesMealPlan?.protein_g?.toFixed(2)) ?? 0 }} g</p>
      </div>
      <div class="macronutrient d-flex flex-column justify-content-center
        align-items-center">
        <img loading="lazy" class="img-macro tw-w-6" src="./assets/images/icons/icons8-heno-100.png"
             alt="">
        <p class="tw-text-xs tw-text-gray-600">Fibra</p>
        <p class="text-bold text-small tw-text-teal-900">{{
          +(nutritionalPropertiesMealPlan?.dietaryFiber_g?.toFixed(2)) ?? 0 }} g</p>
      </div>
    </div>
  </div>
</ng-template>


<!-- ESTANDAR DE DISTRIBUCION DE MACRONUTRIENTES -->
<ng-template #tplStrategyMacros>
  <div class="tw-w-72 md:tw-w-96" *ngIf="standardDistributionValues">
    <p class="tw-text-xs tw-uppercase tw-text-gray-600 tw-mb-5 ">
      <span class="tw-text-xs tw-text-gray-500 tw-uppercase tw-mr-1">estándar de distribución:</span>
      {{ standardDistributionValues.name | getTranslateEnum:'macronutrientsDistribution' }}
    </p>
    <div class="macronutrients macros-in-select d-flex justify-content-between tw-text-teal-900 tw-gap-5">
      <div class="macronutrient d-flex flex-column justify-content-center
        align-items-center">
        <img loading="lazy" class="img-macro tw-w-6"
             src="./assets/images/icons/icons8-sunny-side-up-huevos-100.png"
             alt="">
        <p class="tw-text-xs tw-text-gray-600">Grasas</p>
        <p class="text-bold text-small tw-text-teal-900"> {{ standardDistributionValues.values.lipids }} </p>
      </div>
      <div class="macronutrient d-flex flex-column justify-content-center
        align-items-center">
        <img loading="lazy" class="img-macro tw-w-6"
             src="./assets/images/icons/icons8-pastel-de-nata-100.png" alt="">
        <p class="tw-text-xs tw-text-gray-600">H.C</p>
        <p class="text-bold text-small tw-text-teal-900"> {{ standardDistributionValues.values.carbohydrates }} </p>
      </div>
      <div class="macronutrient d-flex flex-column justify-content-center
        align-items-center">
        <img loading="lazy" class="img-macro tw-w-6" src="./assets/images/icons/icons8-jamon-100.png"
             alt="">
        <p class="tw-text-xs tw-text-gray-600">Proteínas</p>
        <p class="text-bold text-small tw-text-teal-900"> {{ standardDistributionValues.values.protein }} </p>
      </div>
      <div class="macronutrient d-flex flex-column justify-content-center
        align-items-center">
        <img loading="lazy" class="img-macro tw-w-6" src="./assets/images/icons/icons8-heno-100.png"
             alt="">
        <p class="tw-text-xs tw-text-gray-600">Fibra</p>
        <p class="text-bold text-small tw-text-teal-900"> {{ standardDistributionValues.values.fiber }} </p>
      </div>
    </div>
  </div>
</ng-template>

<!-- ALERTAS -->
<ng-template #tplAlerts>
  <div class="tw-w-[280px] sm:tw-w-[500px] md:tw-w-[600px] lg:tw-w-[740px]" *ngIf="distributionMessages">
    <div class="alert">
      <div class="icon info">
        <span nz-icon nzType="warning" nzTheme="outline"></span>
      </div>
      <div>
        <p class="tw-text-xs tw-uppercase tw-text-gray-600 tw-mb-3 tw-mt-1.5">Notificaciones</p>
        <ol >
          <ng-container *ngFor="let message of distributionMessages">
            <li *ngIf="message.length > 0">  <p class="tw-text-teal-900 tw-text-sm tw-mb-1" >
              {{ message }}
            </p></li>
          </ng-container>
        </ol>
      </div>
    </div>
  </div>
</ng-template>

<!-- SEGUIMIENTO DE CALORIAS -->
<ng-template #tplTrackingCalories>
  <div class="tw-w-[280px] sm:tw-w-[500px] md:tw-w-[600px] lg:tw-w-[740px]" *ngIf="trackingCaloriesAlert">
    <div class="alert">
      <div>
        <p class="tw-text-xs tw-uppercase tw-text-gray-600 tw-mb-3">Seguimiento de calorías <span class="tw-py-0.5 tw-px-1 tw-ml-1 tw-mr-0.5 tw-rounded-sm tw-bg-amber-50 tw-text-amber-500">
          {{ trackingCaloriesAlert.type | getTranslateEnum:'calorieTrackingType' }}
        </span> {{ trackingCaloriesAlert.caloriesAdded }} kcal deseadas</p>
        <p class="tw-text-teal-900 tw-text-sm">
          {{ trackingCaloriesAlert.message }}
        </p>
      </div>
    </div>
  </div>
  <p class="text-info" *ngIf="!trackingCaloriesAlert">Es necesario agregar una meta de calorías para ver más información</p>
</ng-template>

<!-- VALORES DE MICRONUTRIENTES -->
<ng-template #tplMicros>
  <div class="tw-w-[280px] sm:tw-w-[500px] md:tw-w-[600px] lg:tw-w-[740px]">
    <p class="tw-text-xs tw-uppercase tw-text-gray-600 tw-mb-5">Micronutrientes del plan de alimentación</p>
    <p *ngIf="micronutrients.length === 0" class="text-info tw-w-full">Agrega ingredientes al plan de alimentación para poder ver los micronutrientes</p>
    <div class="list">
      <div class="micronutrient" *ngFor="let micro of micronutrients">
        <p class="value">{{micro.value}} {{micro.unitMeasurement}}</p>
        <p>{{ micro.name }}</p>
      </div>
    </div>
  </div>
</ng-template>

<!-- PACIENTE -->
<ng-template #tplPatient>
  <div class="tw-w-72 md:tw-w-96">
    <p class="tw-text-xs tw-uppercase tw-text-gray-600 tw-mb-5">Información del paciente</p>
    <div class="tw-flex tw-items-center tw-gap-2">
      <app-avatar-user
        [image]="undefined"
        [name]="'Luis Angel'"
        [lastname]="'Mendoza Lucio'"
        [width]="30"
        [fontSize]="'12px'"></app-avatar-user>
      <p>Luis Angel Mendoza Lucio</p>
    </div>
    <div class="list tw-mt-3">
      <div class="">
        <p class="value">Género</p>
        <img loading="lazy"
             *ngIf="false"
             class="gender-class tw-w-5"
             src="./../../../assets/images/icons/icons8-female-100.png"
             alt=""
        />
        <img loading="lazy"
             *ngIf="true"
             class="gender-class tw-w-5"
             src="./../../../assets/images/icons/icons8-male-100.png"
             alt=""
        />
      </div>
      <div class="">
        <p class="value">Edad</p>
        <p class="tw-text-teal-900">25 años</p>
      </div>
    </div>
    <div class="list tw-mt-3">
      <div class="micronutrient">
        <p class="value">170 cm</p>
        <p>Altura</p>
      </div>
      <div class="micronutrient">
        <p class="value">66 kg</p>
        <p>Peso</p>
      </div>
      <div class="micronutrient">
        <p class="value">24.5</p>
        <p>IMC</p>
      </div>
    </div>
  </div>
</ng-template>


<!-- TEMPLATES DE PLAN ALIMENTICIO  -->
<ng-template #templateDayTpl>
  <p class="tw-text-xs tw-uppercase tw-text-gray-600">
    Empieza tu plan alimenticio para 1 día
  </p>
</ng-template>
<ng-template #templateWeekTpl>
  <p class="tw-text-xs tw-uppercase tw-text-gray-600">
    Empieza tu plan alimenticio con periodos para una semana
  </p>
</ng-template>
<ng-template #templateCustomTpl>
  <p class="tw-text-xs tw-uppercase tw-text-gray-600">
    Empieza tu plan alimenticio desde cero
  </p>
</ng-template>


<!-- TABLA DE RESULTADOS DE SMAE -->
<ng-template #tableSmaeTpl>
  <div class="tw-w-[280px] sm:tw-w-[550px] md:tw-w-[600px]">

    <div>
      <p class="tw-text-xs tw-uppercase tw-text-gray-600 tw-mb-3">Resultados SMAE</p>
    </div>

    <nz-table
      class="smae-table"
      [nzData]="[0]"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzScroll]="{ x: '600px', y: '200px' }"
      nzSize="small">
      <thead>
        <tr>
          <th nzWidth="120"></th>
          <th nzWidth="120">Kcal</th>
          <th nzWidth="120">Proteínas</th>
          <th nzWidth="120">Grasas</th>
          <th nzWidth="120">H. de carbono</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let result of this.smaeResult">
          <td>{{ result.label }}</td>
          <td>{{ result.calories.toFixed(2) }} <span> Kcal</span></td>
          <td>{{ result.protein.toFixed(2) }} <span> g</span></td>
          <td>{{ result.lipids.toFixed(2) }} <span> g</span></td>
          <td>{{ result.carbohydrates.toFixed(2) }} <span> g</span></td>
        </tr>
        <tr *ngIf="(this.smaeResult | calSmaeResult) as footer">
          <td>{{ footer.label }}</td>
          <td [ngClass]="[footer.calories >= 95 && footer.calories <= 105 ? 'tw-text-green-800' : 'tw-text-red-500']">{{ footer.calories.toFixed(2) ?? 0 }} <span> %</span></td>
          <td [ngClass]="[footer.protein >= 95 && footer.protein <= 105 ? 'tw-text-green-800' : 'tw-text-red-500']">{{ footer.protein.toFixed(2) ?? 0 }} <span> %</span></td>
          <td [ngClass]="[footer.lipids >= 95 && footer.lipids <= 105 ? 'tw-text-green-800' : 'tw-text-red-500']">{{ footer.lipids.toFixed(2) ?? 0 }} <span> %</span></td>
          <td [ngClass]="[footer.carbohydrates >= 95 && footer.carbohydrates <= 105 ? 'tw-text-green-800' : 'tw-text-red-500']">{{ footer.carbohydrates.toFixed(2) ?? 0 }} <span> %</span></td>
        </tr>
      </tbody>
    </nz-table>

    <ng-container *ngIf="smaeMacroNutritionalValues">
      <nz-divider class="tw-opacity-0" style="margin-bottom: 5px!important; margin-top: 5px!important;"></nz-divider>

      <div>
        <p class="tw-text-xs tw-uppercase tw-text-gray-600 tw-mb-3">Tabla macronutrimental</p>
      </div>

      <nz-table
        class="smae-table"
        [nzData]="[0]"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        [nzScroll]="{ x: '600px', y: '200px' }"
        nzSize="small">
        <thead>
        <tr>
          <th nzWidth="120"></th>
          <th nzWidth="120">Kcal</th>
          <th nzWidth="120">Proteínas</th>
          <th nzWidth="120">Grasas</th>
          <th nzWidth="120">H. de carbono</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="smaeMacroNutritionalValues[0] as totales">
          <td>{{ totales.label }}</td>
          <td>{{ totales.calories.toFixed(2) }} <span> Kcal</span></td>
          <td>{{ totales.protein.toFixed(2) }} <span> g</span></td>
          <td>{{ totales.lipids.toFixed(2) }} <span> g</span></td>
          <td>{{ totales.carbohydrates.toFixed(2) }} <span> g</span></td>
        </tr>
        <tr *ngIf="smaeMacroNutritionalValues[1] as adequacy">
          <td>{{ adequacy.label }}</td>
          <td [ngClass]="[adequacy.calories >= 0.95 && adequacy.calories <= 1.05 ? 'tw-text-green-800' : '']">{{ (adequacy.calories.toFixed(2) ?? 0) | percent : '1.0-0' : 'en-US' }}</td>
          <td [ngClass]="[adequacy.protein >= 0.95 && adequacy.protein <= 1.05 ? 'tw-text-green-800' : '']">{{ (adequacy.protein.toFixed(2) ?? 0) | percent : '1.0-0' : 'en-US' }}</td>
          <td [ngClass]="[adequacy.lipids >= 0.95 && adequacy.lipids <= 1.05 ? 'tw-text-green-800' : '']">{{ (adequacy.lipids.toFixed(2) ?? 0) | percent : '1.0-0' : 'en-US' }}</td>
          <td [ngClass]="[adequacy.carbohydrates >= 0.95 && adequacy.carbohydrates <= 1.05 ? 'tw-text-green-800' : '']">{{ (adequacy.carbohydrates.toFixed(2) ?? 0) | percent : '1.0-0' : 'en-US' }}</td>
        </tr>
        </tbody>
      </nz-table>
    </ng-container>
  </div>
</ng-template>

<!-- ALERTAS DE COMPARACIÓN TABLA SMAE CON INGREDIENTES DE LOS BLOQUES -->
<ng-template #tplAlertsSmaeIngredientsCount>
  <div class="tw-w-[280px] sm:tw-w-[550px] md:tw-w-[600px] lg:tw-w-[740px]" *ngIf="distributionMessages">
    <div class="tw-flex tw-gap-3 tw-items-center tw-mb-3">
      <div class="icon info">
        <span nz-icon nzType="warning" nzTheme="outline"></span>
      </div>
      <p class="tw-text-xs tw-uppercase tw-text-gray-600">Tabla de porciones objetivo</p>
    </div>
    <p  *ngIf="!hasValueOnSmaeTable"  class="tw-text-xs tw-text-gray-800">Agrega porciones meta en la tabla macronutrimental y agrega ingredientes al plan de alimentación para ver las diferencias.</p>
    <nz-table
      *ngIf="hasValueOnSmaeTable"
      class="smae-table tw-mt-3"
      [nzData]="[0]"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzScroll]="{ x: '700px', y: '200px' }"
      nzSize="small">
      <thead>
      <tr>
        <th nzWidth="140">Categoría</th>
        <th nzWidth="140">Meta</th>
        <th nzWidth="140">Seleccionadas</th>
        <th nzWidth="140">Faltantes</th>
        <th nzWidth="140">Excedentes</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let category of (categoryIngredientsCount | keyvalue)">
        <tr *ngIf="category.value.valueSmaeTable > 0 || category.value.smaePortion > 0" >
          <td>{{ category.value.name }}  <span></span></td>
          <td>{{ category.value.valueSmaeTable.toFixed(2) }} porción(es) <span></span></td>
          <td>{{ category.value.smaePortion.toFixed(2) }} porción(es)<span></span></td>
          <td [class.tw-text-red-800]="category.value.smaePortion < category.value.valueSmaeTable">{{ (category.value.smaePortion > category.value.valueSmaeTable) ? '0.0' : (category.value.valueSmaeTable - category.value.smaePortion).toFixed(2)}} porción(es)<span></span></td>
          <td [class.tw-text-red-800]="category.value.smaePortion > category.value.valueSmaeTable">{{ (category.value.smaePortion > category.value.valueSmaeTable) ? (category.value.smaePortion - category.value.valueSmaeTable).toFixed(2) : '0.0'}} porción(es)<span></span></td>
        </tr>
      </ng-container>
      </tbody>
    </nz-table>
  </div>
</ng-template>

<!-- TEMPLATE PARA INDICAR SI ES ORIGINAL DE DELIE -->
<ng-template #tplOriginalDelie>
</ng-template>

<!-- TEMPLATE PARA VER DIRECTAMENTE LOS PERIODOS CUANDO ES TIPO SMAE -->
<ng-template #tplViewPeriods>
  <p class="tw-text-xs tw-uppercase tw-text-gray-600">
    Ver tiempos de comida del plan de alimentación
  </p>
</ng-template>
